export const MOBILE_AUTOMATED_REVIEWS_MAX_COUNT = 3
